
import React, { useEffect, useState } from 'react'

import "common/css/master.css";


function ContentTbl(props) {
  const { lstContent, lstContentId, contentId, handleChangeContentObj, editContent, deleteContent, handleSelectContent, mediaTypes, orientations } = props;

  const [selContentId, setSelContentId] = useState(0);
  const [lstContentFiltered, setLstcontentFiltered] = useState([]);
  const [contentNameFiltered, setContentNameFiltered] = useState("");
  const [mediaTypeFiltered, setMediaTypeFiltered] = useState("");


  useEffect(() => {
    // console.log("ContentTbl called, contentId", contentId);
    setSelContentId(contentId);
  }, [contentId]);

  useEffect(() => {
    // console.log("ContentTbl called, lstContent", lstContent);
    setLstcontentFiltered(lstContent);
  }, [lstContent]);

  const colgrp = <colgroup>
    <col width="80"></col>
    <col width="40"></col>
    <col width="50"></col>
    <col width="50"></col>
    <col width="25"></col>
    <col width="40"></col>
  </colgroup>



  return (
    <div >
      <div className="col-md-12 col-xs-12 col-centered padding-remove " >
        <table className="tableLayout1" >
          {colgrp}
          <thead>
            <tr>
              <th >
                Content Name
              </th>
              <th >
                Type
              </th>
              <th >
                Layout
              </th>
              <th >
                Created On
              </th>
              <th >
                Select
              </th>
              <th >
                Action
              </th>
            </tr>
          </thead>
        </table>
        <div className="tableDiv" style={{ height: "70vh" }}>
          <table className="tableLayout">
            {colgrp}
            <tbody id="panelContentTbl" >
              {lstContentFiltered &&
                lstContentFiltered.map((content, idx) => (
                  <tr key={content.contentId}
                    onClick={() => handleChangeContentObj(content)}
                    className={content.contentId === selContentId ? "selected" : ''}>
                    <td className="text-left">{content.content}</td>
                    <td className="text-center">{mediaTypes.get(content.mediaTypeId)}</td>
                    <td className="text-center">{orientations.get(content.layoutTypeId)}</td>
                    <td className="text-center">{content.createdDttm}</td>
                    <td className="text-center">
                      <input type="checkbox"
                        className="form-check-input"
                        checked={!!lstContentId && lstContentId.includes(content.contentId)}
                        onChange={() => handleSelectContent(content.contentId)}
                        onClick={(e) => { e.stopPropagation(); }}
                      />
                    </td>
                    <td className="text-center" >
                      <span
                        onClick={(e) => { e.stopPropagation(); editContent(content); }}
                        title="Edit content Details"
                        style={{ textDecoration: "underline", cursor: "pointer", color: "blue", margin: "5px" }}
                      >
                        Edit
                      </span>
                      <span
                        onClick={(e) => { e.stopPropagation(); deleteContent(content); }}
                        title="Delete Content"
                        style={{ textDecoration: "underline", cursor: "pointer", color: "blue", margin: "5px" }}
                      >
                        Delete
                      </span>
                    </td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default ContentTbl